

export interface ISOState {
    getAllSODetails : any;
    getSOSuccessMessage : any;
    getSOErrorMessage : any;
    getSOCodeSuccess : any;
    getSOByIdSuccess : any;
    getSOByIdError : any;
    getInactiveSOSuccess : any;
    getInactiveSOError:  any;
    getCloseSOSuccess: any;
    getCloseSOError:  any;
    getForcastSalesSuccess: any;
    getForcastSalesError: any;
    getaddForcastSalesSuccess : any;
    getaddForcastSalesError: any;
    geteditForcastSalesSuccess : any;
    geteditForcastSalesError:any;
    //dispatch orders
    getDONumberSuccess: any;
    getDONumberError: any;
    addDOSuccess: any;
    addDOError: any;
    getAllDOSuccess: any;
    getAllDOError: any;
    getDOsByPSSuccess : any;
    getDOsByPSError : any;
    getDOdetailsSuccess: any;
    getDOdetailsError: any;
    getAddPackslipsSuccess: any;
    getAddPackSlipsError: any;
    getAllPackSlipsSuccess: any;
    getAllPackSlipsError: any;
    getEditPackSlipsSuccess: any;
    getEditPackSlipsError: any;
    getRpsBasedOnMonthSuccess : any;
    getRpsBasedOnMonthError: any;
    getDosByFormulaIdSuccess:any;
    getDosByFormulaIdError:any;
    inActivatePsSuccess:any;
    inActivatePsError:any;
    getSOsByCustomerIdSuccess:any;
    getSOsByCustomerIdError:any;
    cancelDoSucces:any;
    cancelDoError:any;

}

export const initialSOState : ISOState =  {
    getAllSODetails : null,
    getSOSuccessMessage : null,
    getSOErrorMessage : null,
    getSOCodeSuccess : null,
    getSOByIdSuccess : null,
    getSOByIdError : null,
    getInactiveSOSuccess : null,
    getInactiveSOError:  null,
    getCloseSOSuccess: null,
    getCloseSOError:  null,
    getForcastSalesSuccess: null,
    getForcastSalesError: null,
    getaddForcastSalesSuccess : null,
    getaddForcastSalesError: null,
    geteditForcastSalesSuccess : null,
    geteditForcastSalesError: null,
      //dispatch orders
      getDONumberSuccess: null,
      getDONumberError: null,
      addDOSuccess: null,
      addDOError: null,
      getAllDOSuccess: null,
      getAllDOError: null,
      getDOsByPSSuccess : null,
      getDOsByPSError : null,
      getDOdetailsSuccess:null,
      getDOdetailsError: null,
      getAddPackslipsSuccess: null,
      getAddPackSlipsError:null,
      getAllPackSlipsSuccess: null,
      getAllPackSlipsError: null,
      getEditPackSlipsSuccess:null,
      getEditPackSlipsError: null,
      getRpsBasedOnMonthSuccess : null,
      getRpsBasedOnMonthError: null,
      getDosByFormulaIdSuccess:null,
      getDosByFormulaIdError:null,
      inActivatePsSuccess:null,
      inActivatePsError:null,
      getSOsByCustomerIdSuccess:null,
      getSOsByCustomerIdError:null,
      cancelDoSucces:null,
      cancelDoError:null
  
}